import * as S from "./cmpCargoInfoContent.styles";
import * as T from "../CmpCarInfoContent/cmpCarInfoContent.styles";
import { Button } from "../../../atoms/Buttons";
import { ReactComponent as IconCamera } from "../../../../styles/assets/svg/icon-camera.svg";
import { ReactComponent as IconUpload } from "../../../../styles/assets/svg/icon-upload.svg";
import { ReactComponent as IconLeftArrow } from "../../../../styles/assets/svg/icon-left-arrow.svg";
import { ReactComponent as IconRightArrow } from "../../../../styles/assets/svg/icon-right-arrow.svg";
import { RefObject } from "react";

interface CmpCargoInfoContentProps {
  imgRef: RefObject<HTMLInputElement>;
  camereRef: RefObject<HTMLInputElement>;
  onChangeImg: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onClickCamera: () => void;
  onSave: () => void;
  onClickAlbum: () => void;
  onClickPrev: () => void;
  // userSignUpData: any;
  imgFile: any;
}

export const CmpCargoInfoContent = ({
  imgRef,
  camereRef,
  onChangeImg,
  onClickAlbum,
  onClickPrev,
  onClickCamera,
  onSave,
  // userSignUpData,
  imgFile,
}: CmpCargoInfoContentProps) => {
  return (
    <S.CmpInfoContentLayout>
      <T.CmpInfoHeader>
        <T.CmpInfoStep>
          <p>
            <span>4/9단계</span> 운송기사 자격등록
          </p>
        </T.CmpInfoStep>
        <S.CmpInfolongQuest>
          <span className="colorPrimary">화물운송종사자격증명</span>을
          <p>등록해 주세요</p>
        </S.CmpInfolongQuest>
      </T.CmpInfoHeader>
      <S.ContentMainLayout>
        <S.CmpExplanBox>
          <p>모든 정보가 잘리지 않고 보여야 합니다.</p>
        </S.CmpExplanBox>
        <S.ImgLayout>
          {imgFile.length !== 0 ? (
            <S.CmpImgBox>
              <img
                src={
                  imgFile[0].filename
                    ? `${process.env.REACT_APP_API_HOST}/user/driver-qualification/image/${imgFile[0].filename}`
                    : `${process.env.REACT_APP_API_HOST}${imgFile[0].imageUrl}`
                }
              />
            </S.CmpImgBox>
          ) : (
            <S.CmpCameraBox>
              <IconCamera id="icon-camera" fill="white" />
            </S.CmpCameraBox>
          )}
          <S.CmpUploadButton>
            <div className="row-buttons">
              <T.InputButton color="white" onClick={onClickAlbum}>
                <IconUpload name="upload" width={24} height={24} />
                업로드
              </T.InputButton>
              <input
                id="imgFile"
                ref={imgRef}
                type="file"
                accept="image/*"
                onChange={onChangeImg}
                style={{ display: "none" }}
              />

              {/* <Button
            type="button"
            color="white"
            size="full"
            onClick={onClickCamera}
          >
            <IconCamera
              name="camera"
              width="22px"
              height="20px"
              fill="#1D4ED7"
            />
            사진촬영
          </Button> */}
              <T.InputButton color="white" onClick={onClickAlbum}>
                <IconCamera
                  name="upload"
                  width={24}
                  height={24}
                  fill="#1D4ED7"
                />
                사진 촬영
              </T.InputButton>
              <input
                id="cameraFile"
                ref={camereRef}
                type="file"
                accept="image/*"
                capture="environment"
                // capture="user"
                // onChange={onClickCamera}
                style={{ display: "none" }}
              />
            </div>
          </S.CmpUploadButton>
        </S.ImgLayout>
      </S.ContentMainLayout>
      <T.CmpButtonBox>
        <div className="small">
          <Button
            type="button"
            color="transparent"
            size="full"
            onClick={onClickPrev}
          >
            <IconLeftArrow width={20} height={20} />
            이전
          </Button>
        </div>

        {/* onSave 넣고 진행 */}
        <Button
          type="button"
          size="full"
          disabled={imgFile.length !== 0 ? false : true}
          onClick={onSave}
        >
          다음
          <IconRightArrow width={20} height={20} />
        </Button>
      </T.CmpButtonBox>
    </S.CmpInfoContentLayout>
  );
};
